// Note: I wish we could simply have them as string literals to allow better type safety.
// But we need to occasionally generate them dynamically based on part of the name.
export const landmineNames = {
  'ANALYTICS-PANEL': 'ANALYTICS-PANEL',
  ADS_ALERT_UPGRADE_BUTTON: 'ADS_ALERT_UPGRADE_BUTTON',

  'BOT-BUILDER-SIDEBAR__PRO-LINK-CLICK': 'BOT-BUILDER-SIDEBAR__PRO-LINK-CLICK',
  'BOT-ANALYTICS-CHART-TAB': 'BOT-ANALYTICS-CHART-TAB',
  'BOT-ANALYTICS-FILTER-BY-DATE': 'BOT-ANALYTICS-FILTER-BY-DATE',
  'BOT-ANALYTICS-TOP-DIALOGUES': 'BOT-ANALYTICS-TOP-DIALOGUES',
  'BOT-ANALYTICS-UNANSWERED-QUESTIONS': 'BOT-ANALYTICS-UNANSWERED-QUESTIONS',
  'BOT-ANALYTICS-QA-KEYWORDS': 'BOT-ANALYTICS-QA-KEYWORDS',
  'CONVERSATION-ANALYTICS-EXPORT': 'CONVERSATION-ANALYTICS-EXPORT',
  'BUSINESS-HOURS-AWAY-SETTINGS': 'BUSINESS-HOURS-AWAY-SETTINGS',

  CHABOT_LIMIT_REACHED: 'CHABOT_LIMIT_REACHED',
  'CLICK-TO-MESSENGER__ACTIVATE': 'CLICK-TO-MESSENGER__ACTIVATE',
  'CLICK-TO-MESSENGER__LEGACY-ADS-TABLE':
    'CLICK-TO-MESSENGER__LEGACY-ADS-TABLE',

  'CONNECT-PAGES-MODAL': 'CONNECT-PAGES-MODAL',
  'CONNECT-FB-PAGE-TO-COMPANY-PAGE': 'CONNECT-FB-PAGE-TO-COMPANY-PAGE',
  'DETAILED-DRIP-STATS': 'DETAILED-DRIP-STATS',
  QQ_FOLLOW_UP_ACTIVATION_CHECKBOX: 'QQ_FOLLOW_UP_ACTIVATION_CHECKBOX',
  NOTIFICATION_WIDGET_TRIAL_ENDED_ALERT:
    'NOTIFICATION_WIDGET_TRIAL_ENDED_ALERT',
  PENDING_CONVERSATION_FOLLOW_UP_ACTIVATION_CHECKBOX:
    'PENDING_CONVERSATION_FOLLOW_UP_ACTIVATION_CHECKBOX',
  RESOLVED_CONVERSATION_FOLLOW_UP_ACTIVATION_CHECKBOX:
    'RESOLVED_CONVERSATION_FOLLOW_UP_ACTIVATION_CHECKBOX',
  COMPOSER_INPUT_DISABLE_CHECKBOX: 'COMPOSER_INPUT_DISABLE_CHECKBOX',
  'CREATE-BOT-MODAL': 'CREATE-BOT-MODAL',
  'INVITE-USER-MODAL': 'INVITE-USER-MODAL',
  INTEGRATIONS_NATIVE_INTEGRATIONS: 'INTEGRATIONS_NATIVE_INTEGRATIONS',
  INTEGRATIONS_FACEBOOK_ADS: 'INTEGRATIONS_FACEBOOK_ADS',
  INTEGRATIONS_EMAIL: 'INTEGRATIONS_EMAIL',
  INTEGRATIONS_XRAY: 'INTEGRATIONS_XRAY',
  INTEGRATIONS_ZAPIER: 'INTEGRATIONS_ZAPIER',
  INTEGRATIONS_CONTACT_SUPPRESSION: 'INTEGRATIONS_CONTACT_SUPPRESSION',
  INTEGRATIONS_MM_API: 'INTEGRATIONS_MM_API',
  INTEGRATIONS_JSON_WEBHOOKS: 'INTEGRATIONS_JSON_WEBHOOKS',
  INTEGRATIONS_NOTIFICATIONS: 'INTEGRATIONS_NOTIFICATIONS',
  INTEGRATIONS_MAILCHIMP: 'INTEGRATIONS_MAILCHIMP',
  'OFFERING-FREE-CONSULTATION-MODAL': 'OFFERING-FREE-CONSULTATION-MODAL',

  FEATURE_NO_LONGER_AVAILABLE: 'FEATURE_NO_LONGER_AVAILABLE',

  'LEADS__CONTACTS__GET-CSV': 'LEADS__CONTACTS__GET-CSV',
  'LEADS__CONTACTS__MAKE-CUSTOM-AUDIENCE':
    'LEADS__CONTACTS__MAKE-CUSTOM-AUDIENCE',
  'LEAD-ASSIGNMENT__ACTIVATION-CHECKBOX':
    'LEAD-ASSIGNMENT__ACTIVATION-CHECKBOX',

  'MARKETING-AUTOMATION__CHAT-BLASTER__CALENDAR-BLOCK':
    'MARKETING-AUTOMATION__CHAT-BLASTER__CALENDAR-BLOCK',
  'MARKETING-AUTOMATION__CONNECTIONS__EDIT-CONNECTIONS-HEADER':
    'MARKETING-AUTOMATION__CONNECTIONS__EDIT-CONNECTIONS-HEADER',
  'MARKETING-AUTOMATION__DRIP-CAMPAIGNS__ACCEPTABLE-TIMEBUILDER':
    'MARKETING-AUTOMATION__DRIP-CAMPAIGNS__ACCEPTABLE-TIMEBUILDER',

  'MESSAGING-ADS__AD-DETAILS-SYNC': 'MESSAGING-ADS__AD-DETAILS-SYNC',
  'MESSAGING-ADS__SETUP-DRIP-CAMPAIGN': 'MESSAGING-ADS__SETUP-DRIP-CAMPAIGN',
  'MESSAGING-ADS__ADS-TABLE__EDIT-AD': 'MESSAGING-ADS__ADS-TABLE__EDIT-AD',
  'MESSAGING-ADS__CLICK_MANUAL_SYNC': 'MESSAGING-ADS__CLICK_MANUAL_SYNC',
  NOTIFICATION_WIDGET_EMAIL: 'NOTIFICATION_WIDGET_EMAIL',
  CTM_ADS_PRO_SYNC_MULTIPLE: 'CTM_ADS_PRO_SYNC_MULTIPLE',
  SPONSORED_MESSAGES_PRO_ACTIVATE: 'SPONSORED_MESSAGES_PRO_ACTIVATE',
  CTM_ADS_PRO_SYNC: 'CTM_ADS_PRO_SYNC',
  CTM_ADS_PRO_ACTIVATE: 'CTM_ADS_PRO_ACTIVATE',

  'PROMO-BLASTERS__CREATE-NEW': 'PROMO-BLASTERS__CREATE-NEW',

  'PROMOTIONS__TEAM-UPGRADE': 'PROMOTIONS__TEAM-UPGRADE',
  'PROMOTIONS__PRO-UPGRADE': 'PROMOTIONS__PRO-UPGRADE',

  QA_UNANSWERED_QUESTIONS: 'QA_UNANSWERED_QUESTIONS',
  'RSS-FEED__FEED-DETAILS__SELECT-AUDIENCE':
    'RSS-FEED__FEED-DETAILS__SELECT-AUDIENCE',

  SENDS_USAGE__WARNING: 'SENDS_USAGE__WARNING',
  SENDS_USAGE__TOOLTIP: 'SENDS_USAGE__TOOLTIP',
  SENDS_USAGE__EXCEED_SEND: 'SENDS_USAGE__EXCEED_SEND',
  'SETTINGS__COMPANY-PANEL': 'SETTINGS__COMPANY-PANEL',
  'SETTINGS__USERS-PANEL': 'SETTINGS__USERS-PANEL',

  'SELECT-AUDIENCE': 'SELECT-AUDIENCE',
  'STARTBOTS-DIALOGUE-EDITOR': 'STARTBOTS-DIALOGUE-EDITOR',
  'STARTBOTS-PROMOTERS__COMMENT-GUARDS__EDIT-FB-POST':
    'STARTBOTS-PROMOTERS__COMMENT-GUARDS__EDIT-FB-POST',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__CONDITIONS-EDITOR__CHANGE-OPERATOR':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__CONDITIONS-EDITOR__CHANGE-OPERATOR',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__CONDITIONS-EDITOR__ADD-NEW-RULE':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__CONDITIONS-EDITOR__ADD-NEW-RULE',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__GREET-WITH-STARTBOT':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__GREET-WITH-STARTBOT',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__DESKTOP-GREETING-CHANGE':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__DESKTOP-GREETING-CHANGE',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__MOBILE-GREETING-CHANGE':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__MOBILE-GREETING-CHANGE',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__WEBCHAT-GREETING-DELAY-CHANGE':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__WEBCHAT-GREETING-DELAY-CHANGE',
  'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__REMOVE-MM-GREETING':
    'STARTBOTS-PROMOTERS__CUSTOMER-CHAT__EDIT-CUSTOMER-CHAT__REMOVE-MM-GREETING',
  'CUSTOMER-CHAT-WIDGET__CUSTOM-DISPLAY-PROFILE':
    'CUSTOMER-CHAT-WIDGET__CUSTOM-DISPLAY-PROFILE',
  'CUSTOMER-CHAT-WIDGET__DATA-API': 'CUSTOMER-CHAT-WIDGET__DATA-API',

  'SUMMARY-PAGE-CARD': 'SUMMARY-PAGE-CARD',
  'SMS-ACTIVATE-NUMBER': 'SMS-ACTIVATE-NUMBER',

  'TEMPLATES__CREATE-OR-EXTEND__END__TAKE-ME-THERE':
    'TEMPLATES__CREATE-OR-EXTEND__END__TAKE-ME-THERE',
  'TEMPLATES__CREATE-OR-EXTEND__EXTEND-SUBMIT':
    'TEMPLATES__CREATE-OR-EXTEND__EXTEND-SUBMIT',
  'TEMPLATES__CREATE-OR-EXTEND__CREATE-TEMPLATE-FROM-BOT':
    'TEMPLATES__CREATE-OR-EXTEND__CREATE-TEMPLATE-FROM-BOT',
  'TEMPLATES__BY-CODE__SUBMIT': 'TEMPLATES__BY-CODE__SUBMIT',
  'TEMPLATES__MY-TEMPLATES__OPEN-CREATE':
    'TEMPLATES__MY-TEMPLATES__OPEN-CREATE',

  'TRIGGERS__CREATE-TRIGGER': 'TRIGGERS__CREATE-TRIGGER',

  'USE-CASE-CARD': 'USE-CASE-CARD',

  'WIDGETS__ADDER__ADD-WIDGET': 'WIDGETS__ADDER__ADD-WIDGET',
  'WIDGETS__BUTTONS__POWERED-BY-MM': 'WIDGETS__BUTTONS__POWERED-BY-MM',
  'WIDGETS__BUTTONS__TYPE-BUTTON': 'WIDGETS__BUTTONS__TYPE-BUTTON',
  'WIDGETS__CONDITIONAL-LOGIC': 'WIDGETS__CONDITIONAL-LOGIC',
  'WIDGETS__TEXT__HANDOVER-BUTTON': 'WIDGETS__TEXT__HANDOVER-BUTTON',

  CHAT_BLASTER_SEND_BUTTON: 'CHAT_BLASTER_SEND_BUTTON',
  DRIP_CAMPAIGN_ACTIVATE_BUTTON: 'DRIP_CAMPAIGN_ACTIVATE_BUTTON',
  DRIP_CAMPAIGN_ALERT_UPGRADE_BUTTON: 'DRIP_CAMPAIGN_ALERT_UPGRADE_BUTTON',
  AMBASSADOR_REFERRAL_PAYWALL: 'AMBASSADOR_REFERRAL_PAYWALL',
  'MY_ACCOUNT__ENABLE-DESKTOP-NOTIFICATIONS':
    'MY_ACCOUNT__ENABLE-DESKTOP-NOTIFICATIONS',
  QQ_FOLLOW_UPS: 'QQ_FOLLOW_UPS',
  X_RAY_ACTIVATION: 'X_RAY_ACTIVATION',
  'CONVERT-MERCURY-LEADS': 'CONVERT-MERCURY-LEADS',
  'INSTALLATION-PAGE-UPGRADE': 'INSTALLATION-PAGE-UPGRADE',
  'FREE-TRIAL-EXTEND-BUTTON': 'FREE-TRIAL-EXTEND-BUTTON',
  'NEW-USER-INFO-FLOW-BILLING-STEP': 'NEW-USER-INFO-FLOW-BILLING-STEP',
  OVERAGES_MANAGMENT: 'OVERAGES_MANAGMENT',
  FREE_TRIAL_WARNING: 'FREE_TRIAL_WARNING',
  EMAIL_EDITOR_REMOVE_BRANDING: 'EMAIL_EDITOR_REMOVE_BRANDING',
  INSTALLATION_PAGE_UPGRADE: 'INSTALLATION_PAGE_UPGRADE',
  FREE_TRIAL_EXTEND_BUTTON: 'FREE_TRIAL_EXTEND_BUTTON',
  ACTIVATE_SMS_PHONE_NUMBER: 'ACTIVATE_SMS_PHONE_NUMBER',
  CONNECT_GMAIL_ACCOUNT: 'CONNECT_GMAIL_ACCOUNT',
  AUTOMATIONS_UPGRADE_WARNING: 'AUTOMATIONS_UPGRADE_WARNING',
  AUTOMATIONS_SEND_SMS_ACTION: 'AUTOMATIONS_SEND_SMS_ACTION',
  AUTOMATIONS_SEND_EMAIL_ACTION: 'AUTOMATIONS_SEND_EMAIL_ACTION',
  AUTOMATIONS_GOOGLE_SHEETS_ACTION: 'AUTOMATIONS_GOOGLE_SHEETS_ACTION',
  AUTOMATIONS_FACEBOOK_AD_AUDIENCE_SYNC_ACTION:
    'AUTOMATIONS_FACEBOOK_AD_AUDIENCE_SYNC_ACTION',
  AUTOMATIONS_MAILCHIMP_ACTION: 'AUTOMATIONS_MAILCHIMP_ACTION',
  AUTOMATIONS_SEND_JSON_WEBHOOK_ACTION: 'AUTOMATIONS_SEND_JSON_WEBHOOK_ACTION',
  AUTOMATIONS_ZAPIER_ACTION: 'AUTOMATIONS_ZAPIER_ACTION',
  ACTIVATE_EMAIL_ACCOUNT_MANUAL: 'ACTIVATE_EMAIL_ACCOUNT_MANUAL',
  INBOX_SEND_EMAIL_MESSAGE: 'INBOX_SEND_EMAIL_MESSAGE',
  INBOX_SEND_SMS_MESSAGE: 'INBOX_SEND_SMS_MESSAGE',
  SUBSCRIBE_FROM_TRIAL_PROMO: 'SUBSCRIBE_FROM_TRIAL_PROMO',
  AUTOMATION_SEND_SOLD_EMAIL: 'AUTOMATION_SEND_SOLD_EMAIL',
  XRAY_ADVANCED_SETTINGS: 'XRAY_ADVANCED_SETTINGS',
  DASHBOARD_CHOOSE_PLAN_ACTION: 'DASHBOARD_CHOOSE_PLAN_ACTION',
  KLAVIYO_UPGRADE: 'KLAVIYO_UPGRADE',
  SALESFORCE_UPGRADE: 'SALESFORCE_UPGRADE',
  SENDLANE_UPGRADE: 'SENDLANE_UPGRADE',
  XRAY_DASHBOARD: 'XRAY_DASHBOARD',
};
